import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class LambdaAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_LAMBDA')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_LAMBDA')));

    return this.api;
  }

  async getDadosReceita(cnpj) {
    const input = {
      input: cnpj
    };
    const result = await this.getAPI().getInstance().post(`/testereceita`, input);
    return result;
  }
}

const api = new LambdaAPI();
export default api;
